import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  onClick?: VoidFunction;
}

const CloseButton = ({ onClick }: Props) => {
  return (
    <IconButton
      size="small"
      sx={{ border: '1px solid #486BC2', color: '#486BC2' }}
      onClick={onClick}
    >
      <CloseIcon />
    </IconButton>
  );
};

export default CloseButton;
